// Types
import type { IApresentationProps } from "./types";

export function Apresentation({REP_PROJECT,infocusID}: IApresentationProps) {

    return (
         <div id="teste-teste" data-infocusID={infocusID === 1}
            className="md:absolute
                print:!relative
                print:!left-0
                border-[1px] border-r-[#000]
                last-of-type:border-none
                opacity-100 -left-[100%]
                data-[inFocusID=true]:opacity-0
                data-[inFocusID=true]:left-0
                transition-all duration-[0.38s]
                w-full h-screen flex flex-row justify-between gap-0 p-0
                page-break
            "
        >
            <span className="absolute print:!hidden rounded-[32px]
                    bg-[#067554] w-[170px] h-[170px] flex flex-col items-center justify-between
                    gap-4
                    top-[150px]
                    p-4
                    text-white
                    cursor-default
                    select-none
                "
                style={{
                    left: 'calc(40% - 85px)'
                }}
            >
                <span className="font-bold text-3xl">2023</span>
                <span className="font-medium text-center text-xl">Estudo de mercado</span>
            </span>
            <div className="w-[40%] print:w-full print:!h-[10cm] h-full flex flex-col justify-between p-16 bg-[#04583f]">
                <span className="text-white font-semibold">MCF | Sócios</span>
                <hgroup className="mt-16 upper font-semibold text-6xl text-white space-y-8">
                    <h1 className="text-xl print:!text-[20pt] font-meidum">INCORPORAÇÃO</h1>
                    <h3 className="font-bold max-w-[75%] uppercase print:!text-[8pt]">
                        {REP_PROJECT?.standard.standard || 'N/A'}
                    </h3>
                </hgroup>
                <span className="w-full text-center print:!text-left print:!text-[10pt] font-semibold text-3xl text-white">
                    {REP_PROJECT?.name || 'N/A'}
                </span>
            </div>
            <div className="md:flex-1 print:flex-none print:w-full print:!h-full md:h-full bg-gray-300  overflow-hidden object-fill">
                {/* <span className="w-full h-full bg-[#04583f11] flex"></span> */}
                {/* biome-ignore lint/a11y/useAltText: <explanation> */}
                <img
                    //@ts-ignore
                    src={`${process.env.REACT_APP_API_URL}/builders/real-estate-products/${REP_PROJECT?.id || -1}/photo`}
                    className="w-full h-full object-cover"
                />
            </div>
        </div>
    )
}
